import React from "react";
import {connect} from "react-redux";
import {NavLink, Link} from "react-router-dom";
import logo from '../../images/logos/logo-large.png';
import search from '../../images/icons/search.svg';
import menu from '../../images/icons/menu.svg';
import {openModal} from "../../actions/modal";
import arrowblack from "../../images/icons/arrow-right-black.svg";
import arrowwhite from "../../images/icons/arrow-right-white.svg";

class TopNavigation extends React.Component {
    constructor(props) {
        super(props);
        this.state = {  activeClass: '' };
    }
    componentDidMount() {

        window.addEventListener('scroll', (event) => {
            let stick = ''

            if (window.pageYOffset < 60 ){
                    stick ='';
                } else {
                     stick = 'rob-header--sticky';
                 }
            this.setState({
                activeClass: stick
            })
        })
    }



    render() {
        const {navigation, openModal} = this.props;

        return (
          <header className={`rob-header ${this.state.activeClass}`}>
              <ul className="container">
                  <Link to="/" className="logo"><img src={logo} alt=""/></Link>
                  <nav className="menu">
                      <ul className="nav rob-menu">
                          {navigation.menu.children.map(function (link, index) {
                              let Linkage;
                              if (link.children.length <= 0) {
                                  if(link.noLink === 'true'){
                                      return  <li key={index} className=""><span>{link.title}</span></li>
                                  }

                                  if(link.type === 'external'){
                                      return  <li key={index} className=""><a target="_blank" href={link.link}>{link.title}</a></li>
                                  }
                                  return <li key={index}><NavLink to={link.link}>{link.name}</NavLink></li>
                              } else {

                                  if(link.type === 'external'){
                                      if(link.noLink === 'true'){
                                          Linkage = <span>{link.title}</span>
                                      }else {
                                          Linkage = <a href={link.link} target="_blank">{link.name}</a>
                                      }
                                  }else{
                                      if(link.noLink === 'true'){
                                          Linkage = <span>{link.name}</span>
                                      }else {
                                          Linkage = <NavLink to={link.link}>{link.name}</NavLink>
                                      }
                                  }
                                  return <li className="parent" key={index}>
                                        {Linkage}
                                      <ul className="submenu">
                                          {link.children.map((childLink, childIndex) => {
                                              if (childLink.children.length <= 0) {

                                                  if(childLink.type === 'external'){
                                                      return  <li key={childIndex} className=""><a target="_blank" href={childLink.link}>{childLink.name}</a></li>
                                                  }
                                                  return <li key={childIndex}><NavLink
                                                    to={childLink.link}>{childLink.name}</NavLink></li>
                                              } else {
                                                  let Linkage;
                                                   if(childLink.type === 'external'){
                                                       Linkage =  <a href={childLink.link} target={'blank'}>{childLink.name}
                                                           <img alt="" className="arrow-black" src={arrowblack} />
                                                           <img alt="" className="arrow-white" src={arrowwhite} />
                                                       </a>
                                                  }else{
                                                       Linkage =  <NavLink to={childLink.link}>{childLink.name}
                                                          <img alt="" className="arrow-black" src={arrowblack} />
                                                          <img alt="" className="arrow-white" src={arrowwhite} />
                                                      </NavLink>
                                                  }
                                                  return <li className="parent" key={childIndex}>{Linkage}
                                                      <ul className="submenu">
                                                          {childLink.children.map((grandchildLink, grandchildIndex) => {

                                                              if(grandchildLink.type === 'external'){
                                                                  return  <li key={grandchildIndex} className=""><a target="_blank" href={grandchildLink.link}>{grandchildLink.name}</a></li>
                                                              }
                                                              return <li key={grandchildIndex}><NavLink
                                                                to={grandchildLink.link}>{grandchildLink.name}</NavLink></li>
                                                          })}
                                                      </ul>
                                                  </li>
                                              }
                                          })}
                                      </ul>
                                  </li>
                              }
                          })}
                          <li className="rob-search-li">
                              <button onClick={() => openModal('search', [])}><img src={search} alt=""/></button>
                          </li>
                      </ul>
                  </nav>

                  <ul className="rob-header__mobile">
                      <button onClick={() => openModal('search', [])}><img src={search} alt=""/></button>
                      <button id="rpm-trigger"><img src={menu}  alt=""/></button>
                  </ul>
              </ul>

          </header>
        )
    }
}


function mapStateToProps(state) {
    return {
        navigation: state.navigation
    };
}

export default connect(mapStateToProps, {openModal})(TopNavigation);



// WEBPACK FOOTER //
// ./src/components/navigation/TopNavigation.js